export const UL_TYPE = 'unordered-list';
export const OL_TYPE = 'ordered-list';
export const LI_TYPE = 'list-item';
export const LI_CHILD_TYPE = 'list-item-child';
